import { combineReducers } from 'redux';
import { reducer as customerPriceTablesReducer } from './CustomerPriceTables/customerPriceTablesSlice';
import { reducer as customerMetafieldsReducer } from './Customers/CustomerMetafields/customerMetafieldsSlice';
import { reducer as customersReducer } from './Customers/customersSlice';
import { reducer as messagesReducer } from './Messages/messagesSlice';
import { reducer as priceTablesReducer } from './PriceTables/priceTablesSlice';

const customerReducers = combineReducers({
  customers: customersReducer,
  messages: messagesReducer,
  customerMetafields: customerMetafieldsReducer,
  customerPriceTables: customerPriceTablesReducer,
  priceTables: priceTablesReducer,
});

export default customerReducers;
